package org.multiplatform.kotfolio.pages.kids.ride_to_read.class_2

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("/kids/ride_to_read/class_2/good_play")
@Composable
fun GoodPlayPage() {
    BlogLayout(
        PageProperties(
            "A Good Play",
            ""
        ),
        BlogProperties("Ride To Reader", "Good Play")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {

            SpanText(
                text = "Let Us Read",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We built a ship upon the stairs",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "All made of the back-bedroom chairs",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "And filled it full of sofa pillows",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "To go a-sailing on the billows.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We took a saw and several nails,",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "And water in the nursery pails;",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "And Tom said, \"Let us also take",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "An apple and a slice of cake\";",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which was enough for Tom and me",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "To go a-sailing on, till tea.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We sailed along for days and days,",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "And had the very best of plays;",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "But Tom fell out and hurt his knee,",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "So there was no one left but me.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Hard Words",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Built",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Chairs",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Several",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Knee",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Hurt",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Left",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Nursery",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Enough",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Back Bedroom",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Pillows - A big wave",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Sailing",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Several Nails",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Nursery Pails",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Slice - (કાપવું)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Billows - Great waves",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Pails- buckets",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Saw: A tool to cut wood or metal",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tea: A time in the evening for tea and snacks",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Stairs",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Complete the following sentences.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The children went sailing on the ________________. billows.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "They filled it with ________________. soft pillows",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The poet and his friend took water in the ________________. nursery pail",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tom could not play because he ________________. hurt his knee",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "They carried an apple and a ________________ of cake for their play journey. slice",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The poet and Tom went on the sailing ________________. till tea",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The poet and Tom took a saw and several ________________. nails",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We built a ship upon ________________. the stairs",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "An apple and a ________________. slice of cake",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We sailed along  ________________. for days and days",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "So there was no one ________________. left but me",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Complete the sentence using the correct spelling of the word.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The badminton court was wet.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Mother wipes the floor.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We heard Uncle Jayant shore at night.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A little boy could not reach the white board.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "My four year old sister was asleep on the sofa.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Table-tennis is an indoor game.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Please pour me a glass of juice.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Write 2 rhyming words for each.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "play - clay, May, day",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "cake - bake, shake, lake, take",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "me - tea, bee, she",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "tea - bee, me, sea",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "nail - tail, hail",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "sail - mail",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "stairs - pairs",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Read the lines and answer the questions",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Where did the poet and his friends built the ship?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The poet and his friends built the ship upon the stairs.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Where was the ship built?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The ship was built upon the stairs.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }


                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Where did the children build their ship?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The children built their ship upon the stairs.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Where were the poet and his friend playing?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The poet and his friend were playing on the stairs.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How does the poet build a ship?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The poet built a ship with back-bedroom chairs, and filled it with soft pillows.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Name a few things that they used to build it.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "They used back-bedroom chairs and soft pillows to build the ship.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Name a few things that they used to build it.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "They used back-bedroom chairs and soft pillows to build the ship.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Which eatables did Tom and the poet take along with them?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Tom and the poet carried an apple and a slice of cake with them.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What food items did the children take with them?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The food items that the children took with them were an apple and a slice of cake.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What eatables did they carry for their journey?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "They carried an apple and a slice of cake for their journey.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What snacks Tom and the poet carried on the ship? ",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Tom and the poet took an apple and a slice of cake on the ship.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What others things did the children carry with them apart from the food items?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The other things that the children carried with them apart from the food items were a saw, several nails and water in the nursery pails.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What did the poet and Tom carry the water in?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The poet and Tom carried water in the nursery pails.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What was the ship filled with?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The ship filled with soft pillows.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How many children are there in the poem?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "There are two children in the poem.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What did the poet and his friend take in the nursery pails?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The poet and his friend took water in the nursery pail.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How did Tom get hurt?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Tom felt down and hurt his knees.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What happened to Tom at the end of the game?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "At the end of the game, Tom fell out and hurt his knee.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What happened after Tom and the poet sailed for days and days?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Tom fell out and hurt his knee.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why was the poet left alone in the end?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The poet was left alone in the end because Tom fell out of the ship and hurt his knee.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Who remained till the end of the play?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The poet remained till the end of the play.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How long the poet and Tom sailed for?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The poet and Tom sailed for days and days.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Where did the children build the ship?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Upon the stairs",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "In what did the children carry water along with them?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Nursery pails",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "List the things that they carried on the ship.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "They carried a saw, several. nails, water in the nursery pails, an apple and a slice of cake on the ship.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What did the children fill the back-bedroom chairs with?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Sofa pillows",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Which fruit did the children take with them to eat?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "An apple",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Who fell out at the end of the game?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Tom",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Find the antonym of the word 'hard' from the above extract.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Soft",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Find the synonym of the word 'construct' from the above extract.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Built",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }
            }

            SpanText(
                text = "State True or False.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The poet and his friend built a ship - True",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "They took chocolates to eat - False",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The ship was made of back bedroom chairs – True",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The water was carried in a nursery jug. – False",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "At the end of plays only the poet remained- True",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tom and the poet sailed along for years and years- False",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tom hurt his knee. – True",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The poet fell and hurt his knee - False",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "They sailed for days and days - True",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }
        }
    }
}